import { render, staticRenderFns } from "./AccountHome.vue?vue&type=template&id=38d226a6&scoped=true&"
import script from "./AccountHome.vue?vue&type=script&lang=js&"
export * from "./AccountHome.vue?vue&type=script&lang=js&"
import style0 from "./AccountHome.vue?vue&type=style&index=0&id=38d226a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d226a6",
  null
  
)

export default component.exports